import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Rnd } from 'react-rnd';
import FontAwesome from 'react-fontawesome';

import { roundNumber, copy, isEmpty } from './functions.js';


class AutoscaleSymbolPreviewLayer extends React.Component {

    symbolPath = 'https://www.hundeshop.de/out/pictures/productdesigner/symboles/';
    layerSymbolMinHeight = 0;
    layerSymbolMinWidth = 0;

    constructor(props) {
        super(props);

        const loaderStyle = { 
            width: this.props.contentLayer.dimensions.width + 'px', 
            height: this.props.contentLayer.dimensions.height + 'px',
            lineHeight: this.props.contentLayer.dimensions.height + 'px'
        };

        this.state = {
            height: this.props.contentLayer.dimensions.height,
            width: this.props.contentLayer.dimensions.width,
            contentLayer: copy(this.props.contentLayer),
            symbolSvg: (<div className='layer_content_symbol' >
                <div className="symbol_loader_icon" style={loaderStyle}>
                    <FontAwesome
                        name='circle-o-notch'
                        size='2x'
                        spin
                    />
                </div>
            </div>)
        }

        this.handleSymbolRemove = this.handleSymbolRemove.bind(this);
        this.handleSymbolFlip = this.handleSymbolFlip.bind(this);
        this.initSvgSymbol();
    }

    initSvgSymbol() {

        if (this.props.contentLayer.content == null)
            return null;

        return fetch(this.symbolPath + this.props.contentLayer.content.file)
        .then((response) => response.text())
        .then((responseText) => {

            responseText = responseText.toString();
            if (responseText.indexOf('<svg') > -1)
            {
                responseText = responseText.substr(responseText.indexOf('<svg'));
                responseText = responseText.substr(0, responseText.indexOf('</svg>')) + '</svg>';
            }
            else if (responseText.indexOf('<SVG') > -1)
            {
                responseText = responseText.substr(responseText.indexOf('<SVG'));
                responseText = responseText.substr(0, responseText.indexOf('</SVG>')) + '</SVG>';
            }
            
            this.setState({
                symbolSvg: <div dangerouslySetInnerHTML={{__html:responseText}} className='layer_content_symbol' />
            })
        })
        .catch((error) => {
            console.error(error);
        });
        
    }

    getSvgElements(){
        if (this.symbolPreviewLayer === null || this.symbolPreviewLayer === undefined)
            return null;

        let svgElement = this.symbolPreviewLayer.getElementsByTagName("svg");
        if (svgElement === undefined || svgElement === null || svgElement.length <= 0)
            this.symbolPreviewLayer.getElementsByTagName("SVG");

        return svgElement;
    }

    handleSymbolFlip(e) {
        e.preventDefault();
        const layer = this.props.contentLayer;
        layer.symbolFlip = !layer.symbolFlip;
        this.props.onContentLayerChange(layer);
    }

    handleSymbolRemove(e) {
        this.props.onContentLayerRemove(this.props.contentLayer);
    }

    handleLayerSelect(e) {
        this.props.onContentLayerSelect(this.props.layerIndex);
    }

    componentDidMount() {
        
    }

    componentDidUpdate() {

        const svgElements = this.getSvgElements();

        if (this.props.contentLayer.dimensions.width != this.state.width ||
            this.props.contentLayer.dimensions.height != this.state.height)
        {
            this.state.height = this.props.contentLayer.dimensions.height;
            this.state.width = this.props.contentLayer.dimensions.width;
            this.state.contentLayer = this.props.contentLayer;
        }

        if (svgElements !== undefined && svgElements !== null && svgElements.length >= 1)
        {
            // set svg size
            if (svgElements[0].style != this.state.width || svgElements[0].style.height != this.state.height + 'px')
            {
                svgElements[0].style.width = this.state.width + 'px';
                svgElements[0].style.height = this.state.height + 'px';
            }

            // set svg color
            let pathElements = this.symbolPreviewLayer.getElementsByTagName("path");
            if (pathElements === undefined || pathElements === null || pathElements.length <= 0)
                pathElements = this.symbolPreviewLayer.getElementsByTagName("PATH");

            let colorHex = this.props.activeColor.color_hex;
            if (this.props.contentLayer.color !== undefined && this.props.contentLayer.color != 'inherit')
            {
                colorHex = this.props.contentLayer.color.color_hex;
            }

            for (var pi = 0; pi < pathElements.length; pi++) {
                if (pathElements[pi].style.fill != colorHex)
                    pathElements[pi].style.fill = colorHex;
            }
        }

    }

    isLayerVisible() {
        if (this.props.activePerspective.id != this.props.contentLayer.perspectiveId || 
            this.props.activePerspective.varid != this.state.contentLayer.perspective_varid || 
            this.props.contentLayer.content === '' || 
            this.props.contentLayer.content === null)
            return false;

        return true;
    }


    render() {

        if (!this.isLayerVisible())
            return null;

        // if (this.state.symbolSvg === '' || this.state.symbolSvg === null)
        //     return null;

        const layerStyle = {
            color: this.props.activeColor.color_hex
        };

        if (!this.isLayerVisible())
            layerStyle.display = 'none';

        const layerPositionStyle = {
            top: this.props.contentLayer.dimensions.posY.toString() + 'px',
            left: this.props.contentLayer.dimensions.posX.toString()  + 'px',
            zIndex: 100 - this.props.layerIndex
        };

        const bigHandleStyle = {
            height: this.props.contentLayer.dimensions.height.toString() + 'px',
            lineHeight: this.props.contentLayer.dimensions.height.toString() + 'px'
        };

        return (
            <div ref={ (previewLayer) => this.previewLayer = previewLayer} className={"preview_layer autoscale_layer" + (this.props.contentLayer.symbolFlip ? ' symbol_flip' : '')} style={layerStyle}>
                <div className="layer_position_wrapper" style={layerPositionStyle}>
                    <div className='symbol_svg_layer' ref={ (s) => this.symbolPreviewLayer = s}>
                        {this.state.symbolSvg}
                    </div>

                    {
                        // Render if props.designerRenderMode is 'designer'
                        this.props.designerRenderMode == 'designer' ?
                            this.props.contentLayer.dimensions.width > 68 ?
                            (
                                <div className="layer_symbol_bighandle" style={bigHandleStyle}>
                                    <div className="layer_handle layer_flip_handle" onClick={this.handleSymbolFlip} style={bigHandleStyle}> 
                                        <FontAwesome size="2x" name='star-half-o' className='layer_handle_icon' /> 
                                    </div>
                                    <div className="layer_handle layer_remove_handle" onClick={this.handleSymbolRemove} style={bigHandleStyle}> 
                                        <FontAwesome size="2x" name='trash' className='layer_handle_icon'/> 
                                    </div>
                                </div>
                            ):
                            (
                                <div>
                                    <div className="layer_handle layer_flip_handle" onClick={this.handleSymbolFlip}> <FontAwesome name='star-half-o' className='layer_handle_icon' /> </div>
                                    <div className="layer_handle layer_remove_handle" onClick={this.handleSymbolRemove}> <FontAwesome name='trash' className='layer_handle_icon'/> </div>
                                </div>
                            )
                        :null
                    }
                    
                </div>
            </div>
        );
    }
  }

export default AutoscaleSymbolPreviewLayer;




// WEBPACK FOOTER //
// ./src/AutoscaleSymbolPreviewLayer.js